import { useState, useEffect } from "react";
import { useStore } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { sify } from "chinese-conv";
import _ from "lodash";

import SaveIcon from '@mui/icons-material/Save';
import ClearIcon from '@mui/icons-material/Clear';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CancelIcon from '@mui/icons-material/Cancel';
import { makeStyles } from '@mui/styles';

import { constants } from '../../Constants/constants';
import { post } from "../../helper/baseFetch";
import { EditCreateDisplay } from '../../Component/EditCreateDisplay/EditCreateDisplay';
import { TempTextInput } from "../../Component/Input/TempTextInput";
import { TempAutoSelectInput } from "../../Component/Input/TempAutoSelectInput";
import { TempCustomCheckBox } from "../../Component/Custom/TempCustomCheckBox";
import { GlobalDialog } from "../../Component/GlobalDialog";
import QueueRejectReasonValidation from "../../validations/queueRejectReasonValidation";
import { rejectReasonValidationConstants } from '../../Constants/validationConstants';
import useRestaurant from "../../hooks/Restaurant/useRestaurant";

const helperTextStyles = makeStyles(theme => ({
  root: {
    color: "red !important",
  },
}));

export const ReservationRejectReasonCreate = () => {
  const store = useStore();
  const history = useHistory();
  const params = useParams();
  const [clear, setClear] = useState(false);
  const [dialog, setDialog] = useState({
    open: false,
    dialogActions: []
  });
  const resource = "ReservationRejectReason";
  const helperTextStylesClasses = helperTextStyles();
  const [rejectReason, setRejectReason] = useState({});
  const [, setErrorVersion] = useState(QueueRejectReasonValidation.getVersion());

  const tabs = [
    {
      label: { resource: resource, key: "info" },
      tabIndex: constants.RESERVATION_REJECT_REASON_EDIT_TAB.INFO
    },
  ]
  const tempQueueRejectReasonEditList = [
    {
      className: "edit-create-input",
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: "status" },
      value: rejectReason.status,
      variant: constants.STYLE.VARIANT.STANDARD,
      name: "status",
      isEndOfLine: true,
      disabled: true,
      required: true,
    },
    {
      className: "edit-create-input",
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: "reasonCode" },
      value: rejectReason.reasonCode,
      name: "reasonCode",
      isEndOfLine: true,
    },
    {
      className: "edit-create-input",
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: "enReason" },
      value: rejectReason.enReason,
      name: "enReason",
      custom: true,
      customName: { resource: resource, key: "reasonCustomize" },
      customValue: !!rejectReason.scReasonDisable,
      isEndOfLine: false,
      multiline: true,
      helperTextIcon: true,
      helperText: QueueRejectReasonValidation.getErrorMessages(rejectReasonValidationConstants.KEY_EN_REASON),
      FormHelperTextProps: { className: helperTextStylesClasses.root },
    },
    {
      className: "edit-create-input",
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: "tcReason" },
      value: rejectReason.tcReason,
      name: "tcReason",
      translateName: rejectReason.scReasonDisable ? ["scReason"] : null,
      isEndOfLine: false,
      multiline: true,
    },
    {
      className: "edit-create-input",
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: "scReason" },
      value: rejectReason.scReason,
      name: "scReason",
      isEndOfLine: true,
      disabled: rejectReason.scReasonDisable,
      multiline: true,
    },
  ]
  const content = [
    {
      tab:
        <>
          {QueueRejectReasonValidation.getErrorMessages(rejectReasonValidationConstants.KEY_REST_URL_ID) &&
            QueueRejectReasonValidation.getErrorMessages(rejectReasonValidationConstants.KEY_REST_URL_ID).length > 0 &&
            <div className="error-message">
              <CancelIcon className="error-message-icon" fontSize={constants.SIZE.SMALL} />
              {QueueRejectReasonValidation.getErrorMessages(rejectReasonValidationConstants.KEY_REST_URL_ID)}
            </div>
          }
          {tempQueueRejectReasonEditList.map((inputSetting, index) => {
            let content;
            switch (inputSetting.type) {
              case constants.TYPE.SELECT:
                content =
                  <TempAutoSelectInput inputSetting={inputSetting} handleChange={onChangeInput} />
                break;
              default:
                content =
                  <TempTextInput inputSetting={inputSetting} handleChange={onChangeInput} />
            }
            return <div className="edit-display-wrapper" key={index}>
              {inputSetting.custom && <TempCustomCheckBox value={inputSetting.customValue} className="customize-btn" customName={inputSetting.customName} onSelectCheckbox={onSelectCheckbox} />}
              {content}
              {inputSetting.isEndOfLine && <div></div>}
            </div>
          })}
        </>,
      btn: true
    }
  ]

  const bottomBtns = [
    {
      variant: constants.STYLE.VARIANT.CONTAINED,
      color: constants.STYLE.PRIMARY,
      label: { key: "save" },
      onClick: onClickSave,
      className: "margin-left-16",
      icon: <SaveIcon />
    },
    {
      variant: constants.STYLE.VARIANT.CONTAINED,
      color: constants.STYLE.PRIMARY,
      label: { key: "clear" },
      disabled: false,
      onClick: onClickClear,
      className: "margin-left-16",
      icon: <ClearIcon />
    }
  ]

  function onSelectCheckbox(value, customName) {
    switch (customName.key) {
      case "reasonCustomize":
        if(value) {
          setRejectReason(prev=>({...prev, scReason: prev.tcReason?sify(prev.tcReason):prev.tcReason,scReasonDisable: !!value}))
        } else {
          setRejectReason(prev=>({...prev, scReasonDisable: !!value}))
        }
        break;
      default:
    }
  }

  const onClickBackToCreate = () => {
    setDialog({
      open: false,
      dialogActions: []
    });
    onClickClear();
  }
  const onClickBackToList = () => {
    setDialog({
      open: false,
      dialogActions: []
    })
    history.push("/" + constants.PATH.SHOP.SYSTEM_GROUP_RESTAURANT + "/" + params.restUrlId + "/" + constants.RESTAURANT_TAB.RESERVATION + "/" + constants.RESTAURANT_RESERVATION_SUB_TAB.RESERVATON_REJECT_REASON);
  };

  function onChangeInput(name, e) {
    let changedValue = e ? e : null;
    let tempRejectReason = _.cloneDeep(rejectReason);
    if (name === "tcReason" && tempRejectReason.scReasonDisable === true) {
      tempRejectReason.tcReason = changedValue;
      tempRejectReason.scReason =  changedValue? sify(changedValue): changedValue;
    } else {
      tempRejectReason[`${name}`] = e
    }

    setRejectReason(tempRejectReason);
  }

  function onClickSave() {
    QueueRejectReasonValidation.validateCreateQueueRejectReason(rejectReason);
    if (QueueRejectReasonValidation.isValid()) {
      post(constants.PATH.SHOP.RESERVATION.RESERVATION_REJECT_REASON, rejectReason, (payload) => {
        setDialog({
          open: true,
          onClose: onClickBackToCreate,
          dialogContentText: { key: "createSuccess" },
          dialogActions: [
            { label: { key: "backCreate" }, onClick: onClickBackToCreate, icon: <ArrowBackIcon /> },
            { label: { key: "backList" }, onClick: onClickBackToList, icon: <LowPriorityIcon /> }
          ]
        })
        setClear(false)
      }, undefined, store);
      QueueRejectReasonValidation.resetErrorMessages();
    } else {
      setErrorVersion(QueueRejectReasonValidation.getVersion());
    }
  }

  function onClickClear() {
    setClear(true)
  }

  useEffect(() => {
    QueueRejectReasonValidation.resetErrorMessages();
    let tempQueueRejectReason = _.cloneDeep(constants.QUEUE_REJECT_REASON_INPUT);
    tempQueueRejectReason.restUrlId = params.restUrlId;
    setRejectReason(tempQueueRejectReason);
    setClear(false)
  }, [clear === true]); // eslint-disable-line react-hooks/exhaustive-deps

  const { getRestaurantIdAndName } = useRestaurant(params.restUrlId)
  const mapCode = getRestaurantIdAndName()

  return (
    <>
      <EditCreateDisplay
        code=""
        resource={resource}
        tabs={tabs}
        content={content}
        onChangeInput={onChangeInput}
        bottomBtns={bottomBtns}
        mapName={{ resource: "restaurant", key: "restUrlId" }}
        mapCode={mapCode}
        display="create"
      />
      {dialog && dialog.open &&
        <GlobalDialog dialogInfo={dialog} />
      }
    </>
  )
};